export var ChartPatternKey;
(function (ChartPatternKey) {
    ChartPatternKey["cupHandle"] = "cupHandle";
    ChartPatternKey["doubleBottom"] = "doubleBottom";
    ChartPatternKey["doubleTop"] = "doubleTop";
    ChartPatternKey["ascendingTriangle"] = "ascendingTriangle";
    ChartPatternKey["descendingTriangle"] = "descendingTriangle";
    ChartPatternKey["symmetricalTriangle"] = "symmetricalTriangle";
    ChartPatternKey["bullFlag"] = "bullFlag";
    ChartPatternKey["bearFlag"] = "bearFlag";
    ChartPatternKey["headShoulders"] = "headShoulders";
    ChartPatternKey["inverseHeadShoulders"] = "inverseHeadShoulders";
    ChartPatternKey["risingWedge"] = "risingWedge";
    ChartPatternKey["fallingWedge"] = "fallingWedge";
})(ChartPatternKey || (ChartPatternKey = {}));
export var ChartPatternDirection;
(function (ChartPatternDirection) {
    ChartPatternDirection["bullish"] = "bullish";
    ChartPatternDirection["bearish"] = "bearish";
    ChartPatternDirection["neutral"] = "neutral";
})(ChartPatternDirection || (ChartPatternDirection = {}));
export var ChartPatternSupportStatus;
(function (ChartPatternSupportStatus) {
    ChartPatternSupportStatus["planned"] = "planned";
    ChartPatternSupportStatus["auditing"] = "auditing";
    ChartPatternSupportStatus["approved"] = "approved";
})(ChartPatternSupportStatus || (ChartPatternSupportStatus = {}));
export var ChartPatternState;
(function (ChartPatternState) {
    ChartPatternState["forming"] = "forming";
    ChartPatternState["formed"] = "formed";
    ChartPatternState["triggered"] = "triggered";
    ChartPatternState["successful"] = "successful";
    ChartPatternState["failed"] = "failed";
    ChartPatternState["expired"] = "expired";
})(ChartPatternState || (ChartPatternState = {}));
export var ChartPatternStage;
(function (ChartPatternStage) {
    ChartPatternStage["cupBuilding"] = "cupBuilding";
    ChartPatternStage["handleBuilding"] = "handleBuilding";
    ChartPatternStage["breakoutReady"] = "breakoutReady";
    ChartPatternStage["necklineBuilding"] = "necklineBuilding";
    ChartPatternStage["channelBuilding"] = "channelBuilding";
    ChartPatternStage["trendlineBuilding"] = "trendlineBuilding";
})(ChartPatternStage || (ChartPatternStage = {}));
export var ChartPatternStrictnessTier;
(function (ChartPatternStrictnessTier) {
    ChartPatternStrictnessTier["strict"] = "strict";
    ChartPatternStrictnessTier["standard"] = "standard";
    ChartPatternStrictnessTier["loose"] = "loose";
})(ChartPatternStrictnessTier || (ChartPatternStrictnessTier = {}));
export var ChartPatternEventCategory;
(function (ChartPatternEventCategory) {
    ChartPatternEventCategory["structureFormed"] = "structureFormed";
    ChartPatternEventCategory["breakoutReady"] = "breakoutReady";
    ChartPatternEventCategory["breakoutConfirmed"] = "breakoutConfirmed";
    ChartPatternEventCategory["failed"] = "failed";
    ChartPatternEventCategory["expired"] = "expired";
})(ChartPatternEventCategory || (ChartPatternEventCategory = {}));
export var ChartPatternSource;
(function (ChartPatternSource) {
    ChartPatternSource["internal"] = "internal";
    ChartPatternSource["finnhub"] = "finnhub";
    ChartPatternSource["autochartist"] = "autochartist";
    ChartPatternSource["manual"] = "manual";
})(ChartPatternSource || (ChartPatternSource = {}));
export var ChartPatternAnchorRole;
(function (ChartPatternAnchorRole) {
    ChartPatternAnchorRole["leftLip"] = "leftLip";
    ChartPatternAnchorRole["cupLow"] = "cupLow";
    ChartPatternAnchorRole["rightLip"] = "rightLip";
    ChartPatternAnchorRole["handleLow"] = "handleLow";
    ChartPatternAnchorRole["breakout"] = "breakout";
    ChartPatternAnchorRole["upperStart"] = "upperStart";
    ChartPatternAnchorRole["upperEnd"] = "upperEnd";
    ChartPatternAnchorRole["lowerStart"] = "lowerStart";
    ChartPatternAnchorRole["lowerEnd"] = "lowerEnd";
    ChartPatternAnchorRole["high1"] = "high1";
    ChartPatternAnchorRole["high2"] = "high2";
    ChartPatternAnchorRole["low1"] = "low1";
    ChartPatternAnchorRole["low2"] = "low2";
    ChartPatternAnchorRole["neckline"] = "neckline";
    ChartPatternAnchorRole["poleStart"] = "poleStart";
    ChartPatternAnchorRole["poleEnd"] = "poleEnd";
    ChartPatternAnchorRole["flagHigh"] = "flagHigh";
    ChartPatternAnchorRole["flagLow"] = "flagLow";
    ChartPatternAnchorRole["leftShoulder"] = "leftShoulder";
    ChartPatternAnchorRole["head"] = "head";
    ChartPatternAnchorRole["rightShoulder"] = "rightShoulder";
    ChartPatternAnchorRole["trough1"] = "trough1";
    ChartPatternAnchorRole["trough2"] = "trough2";
})(ChartPatternAnchorRole || (ChartPatternAnchorRole = {}));
const FULL_ROLLOUT_DURATIONS = ['1d', '1w', '1mo', '240m', '180m', '120m', '60m', '30m', '15m', '5m'];
const TRIANGLE_FAMILY_PLANNED_DURATIONS = FULL_ROLLOUT_DURATIONS;
const DAILY_DURATION = '1d';
const WEEKLY_DURATION = '1w';
const FOUR_HOUR_DURATION = '240m';
const THREE_HOUR_DURATION = '180m';
const TWO_HOUR_DURATION = '120m';
const ONE_HOUR_DURATION = '60m';
const THIRTY_MINUTE_DURATION = '30m';
const FIFTEEN_MINUTE_DURATION = '15m';
const FIVE_MINUTE_DURATION = '5m';
const HEAD_AND_SHOULDERS_FAMILY_PLANNED_DURATIONS = FULL_ROLLOUT_DURATIONS;
const buildChartPatternSupportEntries = (config) => config.barDurations.map((barDuration) => ({
    patternKey: config.patternKey,
    direction: config.direction,
    barDuration,
    status: config.statusOverrides?.[barDuration] ?? config.status
}));
export const CHART_PATTERN_SUPPORT_MATRIX = [
    ...buildChartPatternSupportEntries({
        patternKey: ChartPatternKey.cupHandle,
        direction: ChartPatternDirection.bullish,
        barDurations: FULL_ROLLOUT_DURATIONS,
        status: ChartPatternSupportStatus.auditing
    }),
    {
        patternKey: ChartPatternKey.doubleBottom,
        direction: ChartPatternDirection.bullish,
        barDuration: '1d',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.doubleBottom,
        direction: ChartPatternDirection.bullish,
        barDuration: '1w',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.doubleBottom,
        direction: ChartPatternDirection.bullish,
        barDuration: '1mo',
        status: ChartPatternSupportStatus.auditing
    },
    {
        patternKey: ChartPatternKey.doubleBottom,
        direction: ChartPatternDirection.bullish,
        barDuration: '240m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.doubleBottom,
        direction: ChartPatternDirection.bullish,
        barDuration: '180m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.doubleBottom,
        direction: ChartPatternDirection.bullish,
        barDuration: '120m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.doubleBottom,
        direction: ChartPatternDirection.bullish,
        barDuration: '60m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.doubleBottom,
        direction: ChartPatternDirection.bullish,
        barDuration: '30m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.doubleBottom,
        direction: ChartPatternDirection.bullish,
        barDuration: '15m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.doubleBottom,
        direction: ChartPatternDirection.bullish,
        barDuration: '5m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.doubleTop,
        direction: ChartPatternDirection.bearish,
        barDuration: '1d',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.doubleTop,
        direction: ChartPatternDirection.bearish,
        barDuration: '1w',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.doubleTop,
        direction: ChartPatternDirection.bearish,
        barDuration: '1mo',
        status: ChartPatternSupportStatus.auditing
    },
    {
        patternKey: ChartPatternKey.doubleTop,
        direction: ChartPatternDirection.bearish,
        barDuration: '240m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.doubleTop,
        direction: ChartPatternDirection.bearish,
        barDuration: '180m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.doubleTop,
        direction: ChartPatternDirection.bearish,
        barDuration: '120m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.doubleTop,
        direction: ChartPatternDirection.bearish,
        barDuration: '60m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.doubleTop,
        direction: ChartPatternDirection.bearish,
        barDuration: '30m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.doubleTop,
        direction: ChartPatternDirection.bearish,
        barDuration: '15m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.doubleTop,
        direction: ChartPatternDirection.bearish,
        barDuration: '5m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.bullFlag,
        direction: ChartPatternDirection.bullish,
        barDuration: '1d',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.bullFlag,
        direction: ChartPatternDirection.bullish,
        barDuration: '1w',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.bullFlag,
        direction: ChartPatternDirection.bullish,
        barDuration: '1mo',
        status: ChartPatternSupportStatus.auditing
    },
    {
        patternKey: ChartPatternKey.bullFlag,
        direction: ChartPatternDirection.bullish,
        barDuration: '240m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.bullFlag,
        direction: ChartPatternDirection.bullish,
        barDuration: '180m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.bullFlag,
        direction: ChartPatternDirection.bullish,
        barDuration: '120m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.bullFlag,
        direction: ChartPatternDirection.bullish,
        barDuration: '60m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.bullFlag,
        direction: ChartPatternDirection.bullish,
        barDuration: '30m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.bullFlag,
        direction: ChartPatternDirection.bullish,
        barDuration: '15m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.bullFlag,
        direction: ChartPatternDirection.bullish,
        barDuration: '5m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.bearFlag,
        direction: ChartPatternDirection.bearish,
        barDuration: '1d',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.bearFlag,
        direction: ChartPatternDirection.bearish,
        barDuration: '1w',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.bearFlag,
        direction: ChartPatternDirection.bearish,
        barDuration: '1mo',
        status: ChartPatternSupportStatus.auditing
    },
    {
        patternKey: ChartPatternKey.bearFlag,
        direction: ChartPatternDirection.bearish,
        barDuration: '240m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.bearFlag,
        direction: ChartPatternDirection.bearish,
        barDuration: '180m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.bearFlag,
        direction: ChartPatternDirection.bearish,
        barDuration: '120m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.bearFlag,
        direction: ChartPatternDirection.bearish,
        barDuration: '60m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.bearFlag,
        direction: ChartPatternDirection.bearish,
        barDuration: '30m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.bearFlag,
        direction: ChartPatternDirection.bearish,
        barDuration: '15m',
        status: ChartPatternSupportStatus.approved
    },
    {
        patternKey: ChartPatternKey.bearFlag,
        direction: ChartPatternDirection.bearish,
        barDuration: '5m',
        status: ChartPatternSupportStatus.approved
    },
    ...buildChartPatternSupportEntries({
        patternKey: ChartPatternKey.ascendingTriangle,
        direction: ChartPatternDirection.bullish,
        barDurations: TRIANGLE_FAMILY_PLANNED_DURATIONS,
        status: ChartPatternSupportStatus.auditing,
        statusOverrides: {
            [DAILY_DURATION]: ChartPatternSupportStatus.auditing
        }
    }),
    ...buildChartPatternSupportEntries({
        patternKey: ChartPatternKey.descendingTriangle,
        direction: ChartPatternDirection.bearish,
        barDurations: TRIANGLE_FAMILY_PLANNED_DURATIONS,
        status: ChartPatternSupportStatus.auditing,
        statusOverrides: {
            [DAILY_DURATION]: ChartPatternSupportStatus.approved
        }
    }),
    ...buildChartPatternSupportEntries({
        patternKey: ChartPatternKey.symmetricalTriangle,
        direction: ChartPatternDirection.bullish,
        barDurations: TRIANGLE_FAMILY_PLANNED_DURATIONS,
        status: ChartPatternSupportStatus.auditing,
        statusOverrides: {
            [DAILY_DURATION]: ChartPatternSupportStatus.approved
        }
    }),
    ...buildChartPatternSupportEntries({
        patternKey: ChartPatternKey.symmetricalTriangle,
        direction: ChartPatternDirection.bearish,
        barDurations: TRIANGLE_FAMILY_PLANNED_DURATIONS,
        status: ChartPatternSupportStatus.auditing,
        statusOverrides: {
            [DAILY_DURATION]: ChartPatternSupportStatus.approved
        }
    }),
    ...buildChartPatternSupportEntries({
        patternKey: ChartPatternKey.risingWedge,
        direction: ChartPatternDirection.bearish,
        barDurations: TRIANGLE_FAMILY_PLANNED_DURATIONS,
        status: ChartPatternSupportStatus.auditing,
        statusOverrides: {
            [DAILY_DURATION]: ChartPatternSupportStatus.approved,
            [WEEKLY_DURATION]: ChartPatternSupportStatus.approved,
            [FOUR_HOUR_DURATION]: ChartPatternSupportStatus.approved,
            [ONE_HOUR_DURATION]: ChartPatternSupportStatus.approved,
            [THIRTY_MINUTE_DURATION]: ChartPatternSupportStatus.approved,
            [FIFTEEN_MINUTE_DURATION]: ChartPatternSupportStatus.approved,
            [FIVE_MINUTE_DURATION]: ChartPatternSupportStatus.approved
        }
    }),
    ...buildChartPatternSupportEntries({
        patternKey: ChartPatternKey.fallingWedge,
        direction: ChartPatternDirection.bullish,
        barDurations: TRIANGLE_FAMILY_PLANNED_DURATIONS,
        status: ChartPatternSupportStatus.auditing,
        statusOverrides: {
            [DAILY_DURATION]: ChartPatternSupportStatus.approved,
            [WEEKLY_DURATION]: ChartPatternSupportStatus.approved,
            [FOUR_HOUR_DURATION]: ChartPatternSupportStatus.approved,
            [THREE_HOUR_DURATION]: ChartPatternSupportStatus.approved,
            [TWO_HOUR_DURATION]: ChartPatternSupportStatus.approved,
            [ONE_HOUR_DURATION]: ChartPatternSupportStatus.approved,
            [FIVE_MINUTE_DURATION]: ChartPatternSupportStatus.approved
        }
    }),
    ...buildChartPatternSupportEntries({
        patternKey: ChartPatternKey.headShoulders,
        direction: ChartPatternDirection.bearish,
        barDurations: HEAD_AND_SHOULDERS_FAMILY_PLANNED_DURATIONS,
        status: ChartPatternSupportStatus.auditing,
        statusOverrides: {
            [DAILY_DURATION]: ChartPatternSupportStatus.approved,
            [WEEKLY_DURATION]: ChartPatternSupportStatus.approved,
            [FOUR_HOUR_DURATION]: ChartPatternSupportStatus.approved,
            [THREE_HOUR_DURATION]: ChartPatternSupportStatus.approved,
            [TWO_HOUR_DURATION]: ChartPatternSupportStatus.approved,
            [ONE_HOUR_DURATION]: ChartPatternSupportStatus.approved,
            [THIRTY_MINUTE_DURATION]: ChartPatternSupportStatus.approved,
            [FIFTEEN_MINUTE_DURATION]: ChartPatternSupportStatus.approved
        }
    }),
    ...buildChartPatternSupportEntries({
        patternKey: ChartPatternKey.inverseHeadShoulders,
        direction: ChartPatternDirection.bullish,
        barDurations: HEAD_AND_SHOULDERS_FAMILY_PLANNED_DURATIONS,
        status: ChartPatternSupportStatus.auditing,
        statusOverrides: {
            [DAILY_DURATION]: ChartPatternSupportStatus.approved,
            [WEEKLY_DURATION]: ChartPatternSupportStatus.approved,
            [FOUR_HOUR_DURATION]: ChartPatternSupportStatus.approved,
            [THREE_HOUR_DURATION]: ChartPatternSupportStatus.approved,
            [TWO_HOUR_DURATION]: ChartPatternSupportStatus.approved,
            [ONE_HOUR_DURATION]: ChartPatternSupportStatus.approved,
            [THIRTY_MINUTE_DURATION]: ChartPatternSupportStatus.approved,
            [FIFTEEN_MINUTE_DURATION]: ChartPatternSupportStatus.approved
        }
    })
];
const uniqueChartPatternSupportValues = (values) => [...new Set(values)];
export const getChartPatternSupportEntries = (statuses) => {
    if (!statuses?.length) {
        return [...CHART_PATTERN_SUPPORT_MATRIX];
    }
    const allowedStatuses = new Set(statuses);
    return CHART_PATTERN_SUPPORT_MATRIX.filter((entry) => allowedStatuses.has(entry.status));
};
export const getApprovedChartPatternSupportEntries = () => getChartPatternSupportEntries([ChartPatternSupportStatus.approved]);
export const getApprovedChartPatternDurations = () => uniqueChartPatternSupportValues(getApprovedChartPatternSupportEntries().map((entry) => entry.barDuration));
export const getApprovedChartPatternKeys = () => uniqueChartPatternSupportValues(getApprovedChartPatternSupportEntries().map((entry) => entry.patternKey));
export const getApprovedChartPatternDirections = () => uniqueChartPatternSupportValues(getApprovedChartPatternSupportEntries().map((entry) => entry.direction));
export const getChartPatternSupportEntry = (config) => CHART_PATTERN_SUPPORT_MATRIX.find((entry) => entry.patternKey === config.patternKey && entry.direction === config.direction && entry.barDuration === config.barDuration);
export const getChartPatternSupportStatus = (config) => getChartPatternSupportEntry(config)?.status;
export const isChartPatternSupportAuditingOrApproved = (config) => {
    const status = getChartPatternSupportStatus(config);
    return status === ChartPatternSupportStatus.auditing || status === ChartPatternSupportStatus.approved;
};
export const isChartPatternSupportApproved = (config) => getChartPatternSupportStatus(config) === ChartPatternSupportStatus.approved;
//# sourceMappingURL=ChartPatternTypes.js.map